import { useMutation } from "@/api/utils/useQuery"
import { HasuraMutations } from "@/api/hasura/mutations"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import { MutationResult } from "@/api/utils/types"
import {
  IAutoSyncAccount,
  IDisableAutoSyncAccount,
  ISyncAccounts,
} from "./AccountSyncMutator.types"
import { DeleteSynchronizedAccountMutation } from "@/api/hasura/generated/graphql"
import {
  AccountListResyncRequest,
  ResyncRequest,
} from "@/api/backofficeRest/generated/model"

export interface IAccountSync {
  autoSyncAccount(): MutationResult<IAutoSyncAccount>
  disableAutoSyncAccount(): MutationResult<
    IDisableAutoSyncAccount,
    DeleteSynchronizedAccountMutation
  >
  resyncAccounts(): MutationResult<ISyncAccounts>
}

// Nova has never exposed partial resyncs; both entry points always sync everything.
const FULL_SYNC = {
  syncAssets: true,
  syncCustomer: true,
  syncPayments: true,
}

export class AccountSyncClass implements IAccountSync {
  autoSyncAccount() {
    return useMutation({
      ...BackofficeRestMutations.admin.resyncAccount(),
      serializerFn: (data: IAutoSyncAccount): ResyncRequest => ({
        ...data,
        ...FULL_SYNC,
      }),
      invalidateCache: false,
    })
  }

  disableAutoSyncAccount() {
    return useMutation({
      ...HasuraMutations.accountSync.disableAutoSyncAccount(),
      serializerFn: (data: IDisableAutoSyncAccount) => data,
      invalidateCache: false,
    })
  }

  resyncAccounts() {
    return useMutation({
      ...BackofficeRestMutations.admin.resyncAccounts(),
      serializerFn: (data: ISyncAccounts): AccountListResyncRequest => ({
        ...data,
        ...FULL_SYNC,
      }),
      invalidateCache: false,
    })
  }
}

export const AccountSyncMutator = new AccountSyncClass()
